import {User, Card, Availability, AvailabilityCar} from "@/shared/models";

export class BookingContext{
    constructor(obj){
        if(!obj){
            return;
        }

        this.number = obj.number;

        if(obj.availabilityCar){
            this.availabilityCar = new AvailabilityCar(obj.availabilityCar);
        }
    }

    get totalTTC() {
        return this.availabilityCar ? this.availabilityCar.totalTTC : 0;
    }
}
